import IconFont from "@/components/IconFont";
import CopyShareCode from "@/containers/activities/CopyShareCode";
import FooterBtn from "@/containers/activities/FooterBtn";
import SpinPrize from "@/containers/activities/SpinPrize";
import { PRIZE_LIST } from "@/interfaces/pullNewType";
import ActivityLayout from "@/layout/ActivityLayout";
import PullNewServices from "@/service/pullNew.service";
import ActivityContext from "@/utils/actiivityContext";
import getFullWebCdnUrl from "@/utils/getFullWebCdnUrl";
import Image from "next/image";
import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import Link from "next/link";
import React, { ReactElement, useContext, useEffect, useState } from "react";
import { useTranslation } from "next-i18next";
import styles from "@/containers/activities/holiday2022/index.module.scss";
import hasLogin from "@/utils/hasLogin";
import directToClientLogin from "@/utils/directToClientLogin";
import blurDataURL from "@/utils/blurDataURL";
import useInviteShare from "@/hooks/useShare/useInviteShare";
import { ModulesMappings } from "@/interfaces/enums";

export default function Holiday2022() {
	const { t } = useTranslation("activities");
	const activityInfo = useContext(ActivityContext);
	const onShare = useInviteShare(ModulesMappings.holiday2022);

	const [visible, setVisible] = useState(false);
	const [opportunities, setOpportunities] = useState(0);

	useEffect(() => {
		getPrizeTimes();
	}, []);

	const getPrizeTimes = async () => {
		try {
			const data = await PullNewServices.getPrizeTimes();
			setOpportunities(data || 0);
		} catch (error) {
			console.log(error);
		}
	};

	const handleGetRewards = () => {
		setVisible(true);
	};

	return (
		<>
			<Head>
				<meta
					name="viewport"
					content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"
				/>
				<title></title>
			</Head>

			<section className={styles.section}>
				<div>
					<h1>{t("invite-friends-get-free-stocks")}</h1>

					<div className={styles.stocks}>
						{PRIZE_LIST.filter((item) => item.awardName !== "SNDL").map((item) => {
							return (
								<div key={item.title}>
									<Image
										priority={true}
										placeholder="blur"
										blurDataURL={blurDataURL}
										src={item.icon}
										alt="item"
										width={74}
										height={62}
										style={{
											maxWidth: "100%",
											height: "auto",
										}}
									/>
								</div>
							);
						})}

						<div>
							<Image
								src={getFullWebCdnUrl("/pulling-new/stock-bow.webp")}
								alt="item"
								priority={true}
								placeholder="blur"
								blurDataURL={blurDataURL}
								width={74}
								height={62}
								style={{
									maxWidth: "100%",
									height: "auto",
								}}
							/>
						</div>
					</div>

					<div className={styles.getRewardsWrapper}>
						<div className={styles.getRewards} onClick={handleGetRewards}>
							<span>{t("spin-the-wheel")}</span>
							<IconFont type="xiangyoubeifen" className={styles.arrow} />
						</div>
					</div>

					<div className={styles.inter}>
						<h3>
							<i>1.</i>
							<span>{t("invite-your-friends")}</span>
						</h3>
						<div>
							{t("send-them-your-invite-link")}
							<CopyShareCode shareCode={activityInfo?.shareCode || ""} />
							<div className={styles.tips}>{t("if-you-have-a-former-invitation-code")}</div>
						</div>

						<h3>
							<i>2.</i>
							<span>{t("they-get-cash-and-stocks")}</span>
						</h3>
						<p>{t("for-opening-an-account-and")}</p>

						<h3>
							<i>3.</i>
							<span>{t("you-get-free-stocks")}</span>
						</h3>
						<p>{t("you-get-a-stock-up-to")}</p>
					</div>
				</div>

				<FooterBtn
					btnText={t("share-my-invite-link")}
					onClick={() => {
						if (!hasLogin()) {
							directToClientLogin();
							return;
						}
						onShare();
					}}
					bottomChild={
						<div className={styles.btnGroup}>
							<Link href="/activities/holiday2022/invitee">{t("my-invitee")}</Link>
							<i></i>
							<Link href="/activities/holiday2022/rewards">{t("my-rewards")}</Link>
						</div>
					}
				></FooterBtn>

				<SpinPrize
					opportunities={opportunities}
					visible={visible}
					onHidden={() => {
						setVisible(false);
					}}
					onShare={() => {
						setVisible(false);
						onShare();
					}}
					onSpinSuccess={() => {
						setVisible(false);
						getPrizeTimes();
					}}
				/>
			</section>
		</>
	);
}

export const getServerSideProps: GetServerSideProps = async (context) => {
	return {
		props: {
			...(await serverSideTranslations(context.locale as string, ["error", "common", "share", "activities"])),
		},
	};
};

Holiday2022.getLayout = function getLayout(page: ReactElement) {
	return <ActivityLayout>{page}</ActivityLayout>;
};
